import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import {
  RichTextEditor as BaseRichTextEditor,
  useRichTextEditorContext,
} from '@valwin/facto/components';

import {
  BoldButton,
  BulletListButton,
  H1Button,
  H2Button,
  ItalicButton,
  OrderedListButton,
  QuoteButton,
  RedoButton,
  UnderlineButton,
  UndoButton,
} from './buttons';
import { Image } from './image';
import { LinkButton } from './link-button';

/**
 * Toolbar with default translated buttons.
 * You can add custom buttons as children.
 */
export const Toolbar = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation();
  const { onImageUpload } = useRichTextEditorContext();

  return (
    <BaseRichTextEditor.Toolbar
      scrollStartLabel={t('richTextEditor scrollStart')}
      scrollEndLabel={t('richTextEditor scrollEnd')}
      end={
        <>
          <UndoButton />
          <RedoButton />
        </>
      }
    >
      <BoldButton />
      <ItalicButton />
      <UnderlineButton />

      <BaseRichTextEditor.Separator />

      <H1Button />
      <H2Button />

      <BaseRichTextEditor.Separator />

      <BulletListButton />
      <OrderedListButton />

      <BaseRichTextEditor.Separator />

      <LinkButton />
      <QuoteButton />

      {onImageUpload && (
        <>
          <BaseRichTextEditor.Separator />
          <Image />
        </>
      )}

      {children && (
        <>
          <BaseRichTextEditor.Separator />
          {children}
        </>
      )}
    </BaseRichTextEditor.Toolbar>
  );
};
